import { ColorSchemeProvider, MantineProvider } from "@mantine/core";
import { NotificationsProvider } from "@mantine/notifications";
import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import App from "./App";
import { ModalsProvider } from "@mantine/modals";
import { QueryClient, QueryClientProvider } from "react-query";

const AppWrapper = () => {
  const currentColorScheme = localStorage.getItem("colorScheme");
  const [colorScheme, setColorScheme] = useState(currentColorScheme || "light");
  const toggleColorScheme = (value) => {
    setColorScheme(value || (colorScheme === "dark" ? "light" : "dark"));
    localStorage.setItem("colorScheme", value || (colorScheme === "dark" ? "light" : "dark"));
  };

  const queryClient = new QueryClient();
  return (
    <QueryClientProvider client={queryClient}>
      <ColorSchemeProvider colorScheme={colorScheme} toggleColorScheme={toggleColorScheme}>
        <MantineProvider
          withNormalizeCSS
          withGlobalStyles
          theme={{
            colors: {
              svgLightThemeFill: "#fff",
              svgDarkThemeFill: "#fff",
              svgLightThemeBackground: "linear-gradient(45deg, rgb(76, 110, 245) 0%, rgb(21, 170, 191) 100%)",
              svgDarkThemeBackground: "linear-gradient(45deg, rgb(76, 110, 245) 0%, rgb(21, 170, 191) 100%)",
            },
            colorScheme,
          }}
        >
          <ModalsProvider>
            <NotificationsProvider position="top-right" autoClose={3000}>
              <Routes>
                <Route path="/*" element={<App />} />
              </Routes>
            </NotificationsProvider>
          </ModalsProvider>
        </MantineProvider>
      </ColorSchemeProvider>
    </QueryClientProvider>
  );
};

export default AppWrapper;
